
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Això ho ha portat el projecte
                    <a href="${0}">Folksonomy Engine</a>. No dubteu
                    a participar-hi o donar la vostra opinió.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Aquesta eina us permet corregir la llista d'ingredients. Podeu afegir, eliminar o editar la llista d'ingredients
                .
                <br>
                Aquest caràcter <span class="highlight">␣</span> representa un espai.
                <br>
                Aquest caràcter <span class="highlight">↩︎</span> representa un salt de línia. `,
'hb28f1f2ec1744ee9': html`Aquestes propietats són creades i arxivades pels usuaris per a qualsevol tipus d'ús. No dubteu
                    a afegir-ne de pròpies. Les propietats i els valors que creeu
                    <strong>han de ser factuals</strong>. Podeu aprofundir en la
                    <a href="${0}">llista de propietats que ja utilitza la comunitat</a>
                    o explorar la
                    <a href="${1}">documentació de les propietats i el seu motor de cerca</a>.`,
's000a5b76bd3a01c2': `S'estan carregant les propietats...`,
's000d98595e959c1e': `Aconseguiu-la a Google Play`,
's013bdc8cf0d3583d': `Ajudeu-nos amb els ingredients`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Valida el cultiu`,
's03e9c8114521b998': `Editaré els ingredients`,
's05ec315d9308091a': `Icona de cantonades de codi de barres`,
's061eb5af92512c85': `Desat! Pots ajudar amb un altre?`,
's06847c221c4c0bc1': `M'agradaria crear una propietat per a [descriure el vostre cas d'ús]...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Valors agrupats`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `documentació dedicada`,
's0bb2d48532acc455': `Descarrega el fitxer CSV`,
's0d5b7fee0311db68': `Propietat`,
's0fb218abc2e157ed': `Invalida la imatge`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Cancel·la el retall`,
's11a18a69b30b65ed': `Ajudeu-nos a corregir errors a la llista d'ingredients`,
's1205d5f6fccf8e69': `Valor de la propietat`,
's15d64a0a6715285a': `Nova clau`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Àrea de selecció`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ajudeu-nos a corregir la informació nutricional`,
's1e00019dc454872d': `Si us plau, proporcioneu un nom de propietat utilitzant l'atribut property-name.`,
's1e49126af0935a5b': `Llista de productes que utilitzen aquesta propietat`,
's21e73088de6f26f3': `Descarrega-la a l'App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel·lar`,
's2db7b654c0a9bde0': `Documentar la propietat`,
's300b3a6ee4e1252d': str`Coincidència deficient ${0}%`,
's33f786bb6b4f0cf4': `Resultat del cultiu`,
's33f85f24c0f5f008': `Desa`,
's34be4af4e8fec4ae': `Pregunta primer a la comunitat`,
's36d86adc823cbfa6': `Abans de crear una nova propietat, parleu-ne amb la comunitat:`,
's3781d25aa51a736c': `Documentació del motor de folksonomia`,
's383ae4449428b61e': `Restableix el retall`,
's39bcf88721a1e8ee': `Restableix la selecció`,
's39e14e14300694c7': `Documentació i directrius`,
's3b430cfa5c1fe7f4': str`Documentació per a ${0}`,
's3f4e4b52f230a892': `llenç d'imatges`,
's417b90913e05bc17': `Vista prèvia`,
's41f7dca46d3f1b4a': `Valor`,
's422bba9636ce2489': `Centreu la imatge`,
's42dd66b2441566fd': `Icona central`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Afegir un nutrient`,
's453ab0dbb9b5c777': `Canvia la mida a la dreta`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Carregant...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Nombre de productes`,
's4df2f533c0c1e7d0': `Controls d'imatge`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Mou la selecció`,
's4f751fb9b3ed766c': `Creació d'una nova propietat`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Introduïu el nom de la propietat...`,
's55d7249883a98ca1': `sobre aquesta propietat a la wiki d'Open Food Facts`,
's565867d84c04aea2': `Propietats del filtre...`,
's5666afe5cd0166de': `Si us plau, corregiu els errors o modifiqueu el text abans de confirmar.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `S'estan carregant els productes...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ajudeu-nos a corregir la informació nutricional.`,
's5dd6f12783fca34f': `Edita la llista d'ingredients`,
's5e8250fb85d64c23': `Tanca`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edita`,
's66413c24dcf680e2': `Omet`,
's67ae6594857a4d57': `Gràcies per la teva contribució!`,
's6cee7cad81dfedd1': `Imatge retallada`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `APK d'Android`,
's718dea04853f80ae': str`Bona coincidència ${0}%`,
's71a5c9f4b68ef4d4': `Recompte`,
's74cb3d66f6a668e1': `Documentació`,
's787dd11bed0dc88a': `Redimensiona a l'esquerra`,
's7ce4fd9430e80cea': `valor`,
's801a05fa8e881f37': `Més informació sobre la creació de propietats i les directrius:`,
's8038273de2cf8b73': `Seleccioneu una regió per retallar.`,
's839cc2908a5387f2': `Filtra els codis de barres...`,
's86197dcf3e96af64': `Navega i cerca propietats existents`,
's8a63be30a129a59c': `Canvia la mida inferior`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Canvia la mida a la part superior dreta`,
's8db84aa4bc949af2': `Documentar la nova propietat`,
's8f839a03997a16d7': `Veure producte`,
's901ae1e236ac45d3': `Cancel·la l'eliminació`,
's907f7a97c6b29425': `Tingueu en compte que el model de dades pot ser modificat. Feu-ne ús sota la vostra responsabilitat.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredients:`,
's9a7f60fce090ecaf': `No s'han pogut carregar les propietats. Torna-ho a provar més tard.`,
's9b87abd68fb9df45': `No s'ha trobat? Crea una clau nova {value}`,
's9c0f52425fd2f07e': `Pot no coincidir`,
's9fc41f789c63b40d': `Productes`,
'sa1fa766e0d5634d7': `No hi ha puntuació disponible`,
'sa548778b24054030': `Exploreu totes les propietats aportades pel projecte Folksonomy Engine. Aquestes propietats proporcionen metadades i informació addicionals sobre els productes de la base de dades Open Food Facts.`,
'sa63907958bd0ec4b': `Canvia la mida a la part superior esquerra`,
'sa95b4224f685a36a': `Tanca el modal`,
'sab56a1d439576fd6': `Icona de suggeriment`,
'sac47ea2901d04c15': `Canvia la mida a la part inferior esquerra`,
'sb125227d436c2925': `Cerca el concepte de la teva propietat a la base de dades de propietats existent:`,
'sb125568d43642e6f': `Respon preguntes sobre el producte.`,
'sb1c538e038f9b214': str`Molt bona coincidència ${0}%`,
'sb28639570ff3b852': `llista de totes les propietats`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Un cop hàgiu verificat que la vostra propietat no existeix i la comunitat estigui d'acord que és útil, primer l'heu de documentar a la wiki.`,
'sb3d4f79d9d8b71e5': `Envia`,
'sb560fa37a7bfb6c2': `No s'han trobat productes per a aquesta propietat.`,
'sb7f72e4c8a2d3357': `Filtra els valors...`,
'sb8178320160f84ea': `Mostra el retall`,
'sbad7d2734149470b': `Validar`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Totes les preguntes han estat respostes! Gràcies per la teva ajuda!`,
'sbd9a0b2293b3cd3c': `Mida de la porció`,
'sbe472dc3c2685985': `Valor corresponent`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Canvia la mida superior`,
'sc1c08d0cbcc3bd24': `No coincideix`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Solució suggerida`,
'sc681b137e8f604f7': `Confirma la supressió`,
'sc6daf8a31883f8b9': `Mou la imatge`,
'sc895972c88d38ca5': `Propietat de folksonomia`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Files`,
'scb3b0671d7b7f640': `Nou valor`,
'scb489a1a173ac3f0': `Si`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Uneix-te a la discussió de Slack`,
'scdb6cad0b92721bf': `No s'han trobat propietats.`,
'scf23a05631f93732': `Confirma l'eliminació`,
'scfed2f270ef6a3aa': `Selecciona una àrea`,
'sd1022bc1ef9204f7': `Imatge amb zoom`,
'sd1077c055cf9ba6b': `Ajudeu-nos a validar la llista d'ingredients del producte.`,
'sd698d21ddecba56b': `Ei! Ens pots ajudar a millorar la informació del producte responent a les següents parts:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Comprovar si una propietat ja existeix`,
'sdbf806fefc584115': `Hauries de trobar un`,
'sdc673e73b5c13aea': `Elimina`,
'sdc792b75f1edcaba': `Ajudeu-nos a corregir l'ortografia dels ingredients.`,
'sdca5deead576ceee': `Canvia la mida a la part inferior dreta`,
'sdcc2555c5dde524f': `Esteu segur que voleu suprimir aquest element? Aquesta acció no es pot desfer.`,
'se206feec7ec57b28': `per 100 g`,
'se419a9ab36987490': `Invalidar`,
'se5127cf0f92e7e48': `Consell: també podeu trobar el`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Proposaré un millor cultiu`,
'seea3800e27baa686': `Productes individuals`,
'sefaba4adc4ec9219': `Propietats de folksonomia`,
'seffa8ca49175b5f0': `Propietats personalitzades`,
'sf44a6b3b232c28ea': str`Substitueix el valor actual per ${0}`,
'sf4cd86a2f5ef2588': `Codi de barres del producte`,
'sf57a61152168cc81': `Ajudeu-nos a corregir la detecció d'ingredients`,
'sf88b90b8ba23871c': `Coincidència desconeguda`,
'sf9aee319a006c9b4': `Afegeix`,
'sfacbbe968fa7d773': `Nom de la propietat:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Valor corresponent`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  